import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationStore } from "../domain/notification-model";
import AppConstants from "@src/utils/app.constants";
import api from "@src/common/services/api.service";
import { ApplicationResponse } from "@src/common/domain/common.model";

export const fetchDeliveredNotifications = createAsyncThunk<
  any,
  { userId: string; page?: number; size?: number }
>("notification/delivered", async ({ userId, page = 0, size = 20 }) => {
  const url = `${AppConstants.api}/notification/delivered`;
  const response = await api.get<ApplicationResponse<any>>(url, {
    params: { userId, page, size },
  });

  return response.data.data || {};
});

export const fetchReadNotifications = createAsyncThunk<
  any,
  { userId: string; page?: number; size?: number }
>("notification/read", async ({ userId, page = 0, size = 20 }) => {
  const url = `${AppConstants.api}/notification/read`;
  const response = await api.get<ApplicationResponse<any>>(url, {
    params: { userId, page, size },
  });

  return response.data.data || {};
});

export const markAsRead = createAsyncThunk<any, { ids: string[] }>(
  "notification/read",
  async ({ ids }) => {
    const url = `${AppConstants.api}/notification/mark-as-read`;
    const response = await api.put<ApplicationResponse<any>>(url, {
      notifications: ids,
    },
        {
          params:{
            RAR:0
          }
        });

    return response.data.data || "";
  }
);

export const countUnreadNotifications = createAsyncThunk<
  any,
  { userId: string; page?: number; size?: number }
>("notification/count-unread", async ({ userId, page = 0, size = 50 }) => {
  const url = `${AppConstants.api}/notification/count-unread`;
  const response = await api.get<ApplicationResponse<any>>(url, {
    params: { userId, page, size },
  });

  return response.data.data || 0;
});

const NotificationSlice = createSlice({
  name: "notification",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
    count: { status: "loading", error: null, data: 0 },
  } as NotificationStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReadNotifications.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: {},
          error: null,
        };
      })
      .addCase(fetchReadNotifications.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchReadNotifications.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: {},
          error: action.error,
        };
      });
    builder
      .addCase(fetchDeliveredNotifications.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: {},
          error: null,
        };
      })
      .addCase(fetchDeliveredNotifications.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchDeliveredNotifications.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: {},
          error: action.error,
        };
      });
    builder
      .addCase(countUnreadNotifications.pending, (state, action) => {
        state.count = {
          status: "loading",
          data: 0,
          error: null,
        };
      })
      .addCase(countUnreadNotifications.fulfilled, (state, action) => {
        state.count = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(countUnreadNotifications.rejected, (state, action) => {
        state.count = {
          status: "failed",
          data: 0,
          error: action.error,
        };
      });
  },
});

export default NotificationSlice.reducer;
